import { ArtworkSizeEstimator } from './ArtworkSizeEstimator';

export default ArtworkSizeEstimator;
